webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var userStore = {
  state: {
    name: null,
    id: null,
    bgImgClass: ''
  },
  formatPassengerName: function formatPassengerName(passenger) {
    var name = '';
    if (passenger) {
      if (this.state.name === 'amigo') {
        if (passenger.nickname) {
          name = '' + passenger.nickname;
        } else if (passenger.firstname) {
          name = '' + passenger.firstname;
        }
      } else {
        if (passenger.middlename) {
          name = name + ' ' + passenger.middlename;
        }
        if (passenger.lastname) {
          name = name + ' ' + passenger.lastname;
        }
      }
    }
    return name;
  },
  getFirstname: function getFirstname(passenger) {
    var name = '';

    if (passenger) {
      if (passenger.nickname) {
        name = '' + passenger.nickname;
      } else if (passenger.firstname) {
        name = '' + passenger.firstname;
      }
    }
    return name;
  },
  getGenderPrefix: function getGenderPrefix(passenger) {
    var prefix = 'mevrouw';
    if (passenger.gender === 'male') {
      prefix = 'heer';
    }
    return prefix;
  },
  formatPassengerNameLong: function formatPassengerNameLong(passenger) {
    var name = '';
    if (passenger) {
      if (this.state.name === 'amigo') {
        if (passenger.nickname) {
          if (passenger.nickname) {
            name = '' + passenger.nickname;
          }
        } else if (passenger.firstname) {
          name = '' + passenger.firstname;
        }
        if (passenger.middlename) {
          name = name + ' ' + passenger.middlename;
        }
        if (passenger.lastname) {
          name = name + ' ' + passenger.lastname;
        }
      } else {
        if (passenger.initials) {
          name = '' + passenger.initials;
        }
        if (passenger.middlename) {
          name = name + ' ' + passenger.middlename;
        }
        if (passenger.lastname) {
          name = name + ' ' + passenger.lastname;
        }
      }
    }
    return name;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userStore);

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__ = __webpack_require__(27);






var userApi = {};

var checkStatusCode = function checkStatusCode(statusCode) {
  if (statusCode === 400) {
    __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].logOut(true);
  }
};

var responseReader = function responseReader(callback) {
  var myFunc = function myFunc(response) {
    checkStatusCode(response.data.status.code);
    callback(response);
  };
  return myFunc;
};

var downloadPdf = function downloadPdf(data) {
  if (data.data.success) {
    var link = document.createElement('a');
    link.download = true;
    link.href = data.data.url;

    document.body.appendChild(link);

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (iOS) {
      link.click();
    } else {
      var _popUp = window.open(link);
    }
    if (popUp === null || typeof popUp === 'undefined') {
      alert('Het downloaden van dit bestand wordt geblokkeerd. Zorg ervoor dat de pop-ups niet geblokkeerd worden en probeer het daarna opnieuw.');
    }
    document.body.removeChild(link);
  } else {
    alert('Dit bestand kan momenteel niet gedownload worden, probeer het later opnieuw of neem contact met ons op.');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userApi);

userApi.authUser = function (username, password, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/auth-user', {
    email: username,
    resNo: password,
    entityId: __WEBPACK_IMPORTED_MODULE_2__store_entityStore__["a" /* default */].state.id
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getUser = function (callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/user', {
    token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getUpcomingReservation = function (callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/upcoming-reservation', {
    token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getUpcomingReservations = function (callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/upcoming-reservations', {
    token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getPastReservations = function (callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/past-reservations', {
    token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getReservation = function (id, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + id, {
    token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getInvoice = function (id, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + id + '/invoice', {
    token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getVouchers = function (id, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + id + '/vouchers', {
    token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.downloadVoucher = function (id, voucher, name) {
  var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token }, voucher);
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + id + '/download-voucher',
    method: 'POST',
    data: data
  }).then(function (response) {
    downloadPdf(response.data);
  });
};

userApi.downloadInvoice = function (id, invoiceId) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + id + '/download-invoice',
    method: 'POST',
    data: {
      invoice_id: invoiceId,
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(function (response) {
    downloadPdf(response.data);
  });
};

userApi.downloadInvoiceAttachment = function (id) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + id + '/download-invoice-attachment',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(function (response) {
    downloadPdf(response.data);
  });
};

userApi.getParticipants = function (id, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + id + '/participants',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getReservationComponents = function (reservationId, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + reservationId + '/components',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.downloadTravelDocument = function (reservationId, document) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + reservationId + '/travel-document/download',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token,
      fileName: document.name
    }
  }).then(function (response) {
    downloadPdf(response.data);
  });
};

userApi.downloadPassengerDocument = function (reservationId, passengerId, document) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + reservationId + '/passenger/' + passengerId + '/document/download',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token,
      fileName: document.name
    }
  }).then(function (response) {
    downloadPdf(response.data);
  });
};

userApi.downloadParticipantsList = function (reservationId) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + reservationId + '/participants/download',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(function (response) {
    downloadPdf(response.data);
  });
};

userApi.getInsurances = function (reservationId, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + reservationId + '/insurances',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getGeneralInfo = function (reservationId, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + reservationId + '/general-info',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getTravelDocuments = function (reservationId, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + reservationId + '/travel-documents',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.getPassengers = function (reservationId, callback) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + reservationId + '/passengers',
    method: 'POST',
    data: {
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token
    }
  }).then(responseReader(function (response) {
    callback(response.data.data);
  }));
};

userApi.updatePassengerPassport = function (passengerId, data, callback, errorCallback) {
  var dataCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token }, data);

  __WEBPACK_IMPORTED_MODULE_1_axios___default()({
    url: __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/passenger/' + passengerId + '/update/passport',
    method: 'POST',
    data: dataCopy
  }).then(function (response) {
    callback(response.data.data);
  }).catch(function (error) {
    if (errorCallback) {
      errorCallback(error);
    }
  });
};

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);


var userStore = {
  state: {
    loggedIn: false,
    token: null,
    tokenExpired: false
  },
  logIn: function logIn(token) {
    var path = '' + location.hostname;

    this.state.loggedIn = true;
    this.state.token = token;

    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cookie.set('token', token, { expires: 1, domain: path });
  },
  logOut: function logOut(tokenExpired) {
    var path = '' + location.hostname;

    if (tokenExpired) {
      this.state.tokenExpired = true;
    }
    this.state.loggedIn = false;
    this.state.token = null;
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cookie.delete('token', { expires: 1, domain: path });
  },
  isLoggedIn: function isLoggedIn() {
    return this.state.loggedIn;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (userStore);

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ (function(module, exports) {

module.exports = {"graphQlEndpoint":"http://localhost:8000/graphql","restEndpointTest":"http://localhost:8000/api/portal","restEndpoint":"https://plugin.fourseasonstravelgroup.nl/api/portal","restEndpointOnlineTest":"http://95.85.53.177/api/portal"}

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aircruise.2f08fe1.png";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/davincitravel.47393e5.png";

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.f4769f9.eot";

/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(185),
  /* template */
  __webpack_require__(542),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_ga__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_ga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_universal_ga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_entityText__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_partials_entityText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_partials_entityText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_loader__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_partials_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_partials_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_vuetify__ = __webpack_require__(205);












__WEBPACK_IMPORTED_MODULE_0_universal_ga___default.a.initialize('UA-78433887-2');

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('loader', __WEBPACK_IMPORTED_MODULE_4__components_partials_loader___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('entity-text', __WEBPACK_IMPORTED_MODULE_3__components_partials_entityText___default.a);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  vuetify: __WEBPACK_IMPORTED_MODULE_7__plugins_vuetify__["a" /* default */],
  metaInfo: {
    meta: [{ charset: 'utf-8' }, { name: 'viewport', content: 'width=device-width, initial-scale=1' }]
  },
  VueCookie: __WEBPACK_IMPORTED_MODULE_2_vue_cookie___default.a,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App___default.a }
});

$(document).on('click', '.menu-mobile li a, .full-container *', function (e) {
  $('.mobile-menu').slideUp();
});

$(document).on('click', '.menu-mobile li a, button', function (e) {
  setTimeout(calculateMobileTabLiWidth, 500);
});

function calculateMobileTabLiWidth() {
  $('.tab-menu').each(function (e) {

    var tabWidth = $(this).width();
    var liCount = $(this).children('li').length;
    var liWidth = (tabWidth - 30) / liCount;

    $(this).children('li').css('width', liWidth);
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_userAuthStore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      userAuth: __WEBPACK_IMPORTED_MODULE_0__store_userAuthStore__["a" /* default */].state,
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },
  created: function created() {
    this.getCookie();
    this.fetchEntity();
  },

  watch: {
    userAuth: {
      handler: function handler(val) {
        if (!val.loggedIn) {
          this.$router.push('/login');
        }
      },

      deep: true
    }
  },
  methods: {
    getCookie: function getCookie() {
      var path = '' + location.hostname;
      var token = this.$cookie.get('token', { domain: path });
      if (token) {
        __WEBPACK_IMPORTED_MODULE_0__store_userAuthStore__["a" /* default */].logIn(token);

        this.$router.push('/my');
      }
    },
    fetchEntity: function fetchEntity() {
      var path = '' + location.hostname;
      switch (path) {
        case 'mijn.amicitia.nl':
          this.entity.name = 'amicitia';
          this.entity.label = 'Amicitia Reizen';
          this.entity.tel = '078 - 6845353';
          this.entity.telInt = '0031 - 78 6845353';
          this.entity.id = 1;
          this.entity.bgImgClass = 'amicitia-bg';
          this.entity.mailAddress = 'info@amicitia.nl';
          this.entity.website = 'www.amicitia.nl';
          this.entity.websiteLink = 'http://amicitia.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 264';
          this.entity.postboxAddress = '3340 AG Hendrik-Ido-Ambacht';
          break;
        case 'mijn.friendshipcruises.nl':
          this.entity.name = 'friendshipcruises';
          this.entity.label = 'Friendship Cruises';
          this.entity.tel = '+31 (0)88 - 13 07 300';
          this.entity.telInt = '';
          this.entity.id = 2;
          this.entity.bgImgClass = 'friendshipcruises-bg';
          this.entity.mailAddress = 'info@friendshipcruises.nl';
          this.entity.website = 'www.friendshipcruises.nl';
          this.entity.websiteLink = 'http://friendshipcruises.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 7';
          this.entity.postboxAddress = '3340 AA Hendrik-Ido-Ambacht';
          break;
        case 'mijn.hannick.nl':
          this.entity.name = 'hannick';
          this.entity.label = 'Hannick Reizen B.V.';
          this.entity.tel = '070 - 3191929';
          this.entity.telInt = '0031 - 70 3191929';
          this.entity.id = 3;
          this.entity.bgImgClass = 'hannick-bg';
          this.entity.mailAddress = 'info@hannick.nl';
          this.entity.website = 'www.hannick.nl';
          this.entity.websiteLink = 'http://hannick.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 165';
          this.entity.postboxAddress = '3340 AD Hendrik-Ido-Ambacht';
          break;
        case 'mijn.amigoreizen.nl':
          this.entity.name = 'amigo';
          this.entity.label = 'AmiGO Reizen';
          this.entity.tel = '078 - 6845350';
          this.entity.telInt = '0031 - 78 6845350';
          this.entity.id = 6;
          this.entity.bgImgClass = 'amigo-bg';
          this.entity.mailAddress = 'info@amigoreizen.nl';
          this.entity.website = 'www.amigoreizen.nl';
          this.entity.websiteLink = 'http://amigoreizen.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 264';
          this.entity.postboxAddress = '3340 AG Hendrik-Ido-Ambacht';
          break;
        case 'mijn.davincitravel.nl':
          this.entity.name = 'davincitravel';
          this.entity.label = '';
          this.entity.tel = '';
          this.entity.telInt = '';
          this.entity.id = 8;
          this.entity.bgImgClass = '';
          this.entity.mailAddress = '';
          this.entity.website = '';
          this.entity.postcodeCity = '';
          this.entity.postbox = '';
          this.entity.postboxAddress = '';
          break;
        case 'mijn.aircruise.nl':
          this.entity.name = 'aircruise';
          this.entity.label = 'Air Cruise Collection';
          this.entity.tel = '+ 31 (0) 88 130 73 80';
          this.entity.telInt = '';
          this.entity.id = 5;
          this.entity.bgImgClass = 'aircruise-bg';
          this.entity.mailAddress = 'info@aircruisecollection.nl';
          this.entity.website = 'www.aircruisecollection.nl';
          this.entity.websiteLink = 'http://aircruisecollection.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = '';
          this.entity.postboxAddress = '';
          break;
        case 'mijn.ncrv-reizen.nl':
        case 'mijn.ncrvreizen.nl':
          this.entity.name = 'ncrv-reizen';
          this.entity.label = 'NCRV Reizen';
          this.entity.tel = '088 - 1307360';
          this.entity.telInt = '0031 - 88 1307360';
          this.entity.id = 10;
          this.entity.bgImgClass = 'ncrv-reizen-bg';
          this.entity.mailAddress = 'info@ncrv-reizen.nl';
          this.entity.website = 'www.ncrv-reizen.nl';
          this.entity.websiteLink = 'http://ncrv-reizen.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 7';
          this.entity.postboxAddress = '3340 AG Hendrik-Ido-Ambacht';
          break;
        case 'mijn.agroreizen.nl':
          this.entity.name = 'agro';
          this.entity.label = 'Agro reizen';
          this.entity.tel = '026 351 20 87';
          this.entity.telInt = '+31 (0)26 351 20 87';
          this.entity.id = 11;
          this.entity.bgImgClass = 'agro-bg';
          this.entity.mailAddress = 'info@agroreizen.nl';
          this.entity.website = 'www.agroreizen.nl';
          this.entity.websiteLink = 'https://agroreizen.nl';
          this.entity.postcodeCity = '6811 JL  ARNHEM';
          this.entity.postbox = '';
          this.entity.postboxAddress = '';
          break;
        default:
          this.entity.name = 'amigo';
          this.entity.label = 'AmiGO Reizen';
          this.entity.tel = '078 - 6845350';
          this.entity.telInt = '0031 - 78 6845350';
          this.entity.id = 6;
          this.entity.bgImgClass = 'amigo-bg';
          this.entity.mailAddress = 'info@amigoreizen.nl';
          this.entity.website = 'www.amigoreizen.nl';
          this.entity.websiteLink = 'http://amigoreizen.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 264';
          this.entity.postboxAddress = '3340 AG Hendrik Ido Ambacht';
          break;
      }
      this.entity.banner = this.entity.name + '-banner';
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_userAuthStore__ = __webpack_require__(27);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      username: null,
      password: null,
      usernameInvalid: false,
      passwordInvalid: false,
      combinationInvalid: false,
      connectionError: false,
      authSuccess: false,
      userAuth: __WEBPACK_IMPORTED_MODULE_3__store_userAuthStore__["a" /* default */].state,
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass(this.entity.name);
    if (this.entity.bgImgClass !== '') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass(this.entity.bgImgClass);
    }
  },
  destroyed: function destroyed() {
    if (this.entity.bgImgClass !== '') {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').removeClass(this.entity.bgImgClass);
    }
  },

  computed: {
    error: function error() {
      return this.usernameInvalid || this.passwordInvalid || this.combinationInvalid || this.connectionError || this.userAuth.tokenExpired;
    }
  },
  methods: {
    submitUser: function submitUser() {
      var _this = this;

      this.combinationInvalid = false;
      this.connectionError = false;
      this.connectionError = false;
      this.userAuth.tokenExpired = false;

      this.usernameInvalid = !this.username;
      this.passwordInvalid = !this.password;

      if (!this.error) {
        __WEBPACK_IMPORTED_MODULE_2__api_userApi__["a" /* default */].authUser(this.username, this.password, function (data, connectionError) {
          _this.connectionError = connectionError;

          if (!_this.connectionError) {
            _this.combinationInvalid = !data.validCombi;

            if (data.success) {
              __WEBPACK_IMPORTED_MODULE_3__store_userAuthStore__["a" /* default */].logIn(data.token);

              _this.$router.push('/my');
            }
          }
        });
      }
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_entityTexts_json__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_entityTexts_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_entityTexts_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['text'],
  data: function data() {
    return {
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },

  computed: {
    outText: function outText() {
      var outText = '{{ ' + this.text + ' }}';

      if (__WEBPACK_IMPORTED_MODULE_0__config_entityTexts_json___default.a[this.text][this.entity.name]) {
        outText = __WEBPACK_IMPORTED_MODULE_0__config_entityTexts_json___default.a[this.text][this.entity.name];
      } else if (__WEBPACK_IMPORTED_MODULE_0__config_entityTexts_json___default.a[this.text]['default']) {
          outText = __WEBPACK_IMPORTED_MODULE_0__config_entityTexts_json___default.a[this.text]['default'];
        }

      return outText;
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['show']
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_userAuthStore__ = __webpack_require__(27);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['loggedIn'],
  data: function data() {
    return {
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },

  methods: {
    menuToggle: function menuToggle(event) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.mobile-menu').slideToggle();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target).toggleClass('active');
    },
    logOut: function logOut() {
      __WEBPACK_IMPORTED_MODULE_2__store_userAuthStore__["a" /* default */].logOut(false);
    }
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'passport',
  props: {
    passenger: {
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      city_of_birth: '',
      country_of_birth: '',
      passport_number: '',
      passport_city: '',
      passport_country: '',
      date_issue_passport: '',
      passport_expire_date: '',
      editing: false,
      errors: {}
    };
  },

  watch: {
    passenger: function passenger() {
      this.setDataFromPassenger();
    }
  },
  mounted: function mounted() {
    this.setDataFromPassenger();
  },

  methods: {
    setDataFromPassenger: function setDataFromPassenger() {
      this.city_of_birth = this.passenger.city_of_birth;
      this.country_of_birth = this.passenger.country_of_birth;
      this.passport_number = this.passenger.passport_number;
      this.passport_city = this.passenger.passport_city;
      this.passport_country = this.passenger.passport_country;
      this.date_issue_passport = this.passenger.passport_issue_date;
      this.passport_expire_date = this.passenger.passport_expire_date;
    },
    getDataForUpdate: function getDataForUpdate() {
      return {
        city_of_birth: this.city_of_birth,
        country_of_birth: this.country_of_birth,
        passport_number: this.passport_number,
        passport_city: this.passport_city,
        passport_country: this.passport_country,
        date_issue_passport: this.date_issue_passport,
        passport_expire_date: this.passport_expire_date
      };
    },
    edit: function edit() {
      this.editing = true;
    },
    save: function save() {
      var _this = this;

      var passengerId = this.passenger.id;
      var data = this.getDataForUpdate();
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].updatePassengerPassport(passengerId, data, function () {
        _this.$emit('reload');
        _this.editing = false;
        _this.errors = {};
      }, function (error) {
        _this.errors = error.response.data;
      });
    },
    cancel: function cancel() {
      this.editing = false;
      this.setDataFromPassenger();
    },
    hasError: function hasError(index) {
      if (this.errors[index]) {
        return this.errors[index][0];
      }
      return null;
    }
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_menuLeft__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__partials_menuLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__partials_menuLeft__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_userAuthStore__ = __webpack_require__(27);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      userAuth: __WEBPACK_IMPORTED_MODULE_3__store_userAuthStore__["a" /* default */].state,
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },

  components: {
    menuLeft: __WEBPACK_IMPORTED_MODULE_2__partials_menuLeft___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').addClass(this.entity.name);
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },

  computed: {
    pageTitle: function pageTitle() {
      return 'Contact';
    },
    mailAddress: function mailAddress() {
      return this.entity.mailAddress;
    },
    mailToAddress: function mailToAddress() {
      return 'mailto:' + this.entity.mailAddress;
    },
    telTo: function telTo() {
      var str = this.cleanPhoneNumber(this.entity.tel);
      return 'tel:' + str;
    },
    telIntTo: function telIntTo() {
      var str = this.cleanPhoneNumber(this.entity.telInt);
      return 'tel:' + str;
    }
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    cleanPhoneNumber: function cleanPhoneNumber(str) {
      var str2 = str;
      str2 = str2.replace(/\s/g, '');
      str2 = str2.replace('-', '');
      str2 = str2.replace('(', '');
      str2 = str2.replace(')', '');
      str2 = str2.replace('+', '');
      return str2;
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {},
      upcomingRes: {
        travel_package: {},
        departure: {},
        partner: {},
        entity: {}
      },
      isLoadingUser: true,
      isLoadingReservation: true,
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },

  computed: {
    pageTitle: function pageTitle() {
      var name = __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].formatPassengerName(this.user);
      var prefix = 'Welkom';
      if (__WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state.name === 'amigo') {
        prefix = 'Hoi';
      } else {
        var genderPrefix = __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].getGenderPrefix(this.user);

        prefix = 'Geachte ' + genderPrefix;
      }
      var pageTitle = prefix + ' ' + name;
      return pageTitle;
    }
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoadingUser = true;
      this.isLoadingReservation = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getUser(function (data) {
        _this.user = data.user;
        _this.isLoadingUser = false;
      });
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getUpcomingReservation(function (data) {
        _this.upcomingRes = data.upcoming_reservation;
        _this.isLoadingReservation = false;
      });
    }
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_partials_passport__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_partials_passport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_partials_passport__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      user: {},
      isLoading: true,
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getUser(function (data) {
        _this.user = data.user;
        _this.isLoading = false;
      });
    }
  },
  components: {
    passport: __WEBPACK_IMPORTED_MODULE_2__components_partials_passport___default.a
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_entityStore__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      entity: __WEBPACK_IMPORTED_MODULE_0__store_entityStore__["a" /* default */].state
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {}
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reservations: [],
      isLoading: true,
      prefix: 'vorige'
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getPastReservations(function (data) {
        _this.reservations = data.past_reservations;
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reservations_component_view__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reservations_component_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_reservations_component_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reservations_flights_view__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_reservations_flights_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_reservations_flights_view__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['travelPackageId', 'departureId', 'reservationId'],
  data: function data() {
    return {
      components: [],
      flights: [],
      selectedComponent: null,
      isLoading: true
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    travelPackageId: 'fetchData'
  },
  methods: {
    selectComponent: function selectComponent(component) {
      this.selectedComponent = component;
    },
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getReservationComponents(this.reservationId, function (data) {
        data.components.forEach(function (component) {
          if (component.type === 'flight') {
            _this.flights.push(component);
          } else {
            _this.components.push(component);
          }
        });
        _this.isLoading = false;
      });
    },
    getIconClass: function getIconClass(component) {
      return {
        fa: true,
        'fa-plane': component.type === 'flight',
        'fa-bed': component.type === 'hotel',
        'fa-ship': component.type === 'ship',
        'fa-taxi': component.type === 'pickUp',
        'fa-tree': component.type === 'activity',
        'fa-cube': component.type === 'arrangement'
      };
    },
    formatName: function formatName(passenger) {
      return __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].formatPassengerName(passenger);
    }
  },
  components: {
    componentView: __WEBPACK_IMPORTED_MODULE_2__components_reservations_component_view___default.a,
    flightsView: __WEBPACK_IMPORTED_MODULE_3__components_reservations_flights_view___default.a
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_entityStore__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['component'],
  computed: {
    iconClass: function iconClass() {
      if (this.component) {
        return {
          fa: true,
          'fa-plane': this.component.type === 'flight',
          'fa-bed': this.component.type === 'hotel',
          'fa-ship': this.component.type === 'ship',
          'fa-bus': this.component.type === 'pickUp',
          '': this.component.type === 'activity',
          'fa-cube': this.component.type === 'arrangement'
        };
      }
      return {};
    }
  },
  methods: {
    formatName: function formatName(passenger) {
      if (__WEBPACK_IMPORTED_MODULE_0__store_entityStore__["a" /* default */].state.name === 'amigo') {
        return passenger.salutation + ' ' + passenger.initials + ' ' + passenger.middlename + ' ' + passenger.lastname;
      }
      return passenger.salutation + ' ' + passenger.initials + ' ' + __WEBPACK_IMPORTED_MODULE_0__store_entityStore__["a" /* default */].formatPassengerName(passenger);
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_json__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_userAuthStore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reservations_voucher_list__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_reservations_voucher_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_reservations_voucher_list__);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId', 'reservation'],
  data: function data() {
    return {
      isLoading: true,
      travelDocuments: [],
      passengers: [],
      token: __WEBPACK_IMPORTED_MODULE_3__store_userAuthStore__["a" /* default */].state.token
    };
  },

  computed: {
    downloadUrl: function downloadUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__config_json__["restEndpoint"] + '/reservation/' + this.reservationId + '/travel-document/download';
    }
  },
  created: function created() {
    this.fetchData();
  },

  watch: {},
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getTravelDocuments(this.reservationId, function (data) {
        _this.travelDocuments = data.travelDocuments;
        _this.isLoading = false;
      });
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getPassengers(this.reservationId, function (data) {
        _this.passengers = data.passengers;
        _this.isLoading = false;
      });
    },
    formatName: function formatName(passenger) {
      if (__WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state.name === 'amigo') {
        return passenger.salutation + ' ' + passenger.initials + ' ' + passenger.middlename + ' ' + passenger.lastname;
      }
      return passenger.salutation + ' ' + passenger.initials + ' ' + __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].formatPassengerName(passenger);
    },
    downloadTravelDocument: function downloadTravelDocument(travelDocument) {
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].downloadTravelDocument(this.reservationId, travelDocument);
    },
    downloadPassengerDocument: function downloadPassengerDocument(passenger, document) {
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].downloadPassengerDocument(this.reservationId, passenger.id, document);
    }
  },
  components: {
    voucherList: __WEBPACK_IMPORTED_MODULE_4__components_reservations_voucher_list___default.a
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['flights']
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId'],
  data: function data() {
    return {
      passengers: [],
      flights: [],
      selectedComponent: null,
      isLoading: true
    };
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getInsurances(this.reservationId, function (data) {
        _this.passengers = data.insurances;
        _this.isLoading = false;
      });
    },
    getRateIcon: function getRateIcon(rateType) {
      if (rateType === 'Percentage') {
        return '%';
      }
      return '€';
    },
    formatName: function formatName(passenger) {
      return __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].formatPassengerName(passenger);
    },
    hasInsurances: function hasInsurances() {
      var hasInsurances = false;
      this.passengers.forEach(function (passenger) {
        if (passenger.insurances.length > 0) {
          hasInsurances = true;
        }
      });
      return hasInsurances;
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_json__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_userAuthStore__ = __webpack_require__(27);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId'],
  data: function data() {
    return {
      invoice: {},
      isLoading: true,
      token: __WEBPACK_IMPORTED_MODULE_2__store_userAuthStore__["a" /* default */].state.token
    };
  },

  computed: {
    invoiceDownloadUrl: function invoiceDownloadUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__config_json__["restEndpoint"] + '/reservation/' + this.reservationId + '/download-invoice';
    },
    invoiceAttachmentDownloadUrl: function invoiceAttachmentDownloadUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__config_json__["restEndpoint"] + '/reservation/' + this.reservationId + '/download-invoice-attachment';
    }
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getInvoice(this.reservationId, function (data) {
        _this.invoice = data.invoice;
        _this.isLoading = false;
      });
    },
    downloadInvoice: function downloadInvoice() {
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].downloadInvoice(this.reservationId, this.invoice.id);
    },
    downloadInvoiceAttachment: function downloadInvoiceAttachment() {
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].downloadInvoiceAttachment(this.reservationId);
    },
    roundUp: function roundUp(value) {
      if (typeof value !== 'undefined') {
        return parseFloat(value).toFixed(2);
      }
      return '';
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__ = __webpack_require__(27);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId'],
  data: function data() {
    return {
      participants: [],
      loadingOne: true,
      loadingTwo: true,
      generalInfo: {},
      token: __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.token,
      entity: __WEBPACK_IMPORTED_MODULE_2__store_entityStore__["a" /* default */].state
    };
  },

  computed: {
    isLoading: function isLoading() {
      return this.loadingOne || this.loadingTwo;
    },
    ageCategories: function ageCategories() {
      var _this = this;

      var ageCategories = [];
      if (typeof this.generalInfo.age_categories !== 'undefined' && this.generalInfo.age_categories !== {}) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.generalInfo.age_categories);

        keys.forEach(function (item) {
          var currentAgeCategory = _this.generalInfo.age_categories[item];

          if (typeof currentAgeCategory === 'undefined') return;

          if (_this.entity.name === 'amigo') {
            if (item === '46-55' || item === '56-65' || item === '66-75' || item === '76 en ouder') return;
          }
          var newCategory = {
            name: item,
            percentage: currentAgeCategory.percentage
          };
          ageCategories.push(newCategory);
        });
      }
      return ageCategories;
    },
    malePercentage: function malePercentage() {
      var malePercentage = '0';
      if (typeof this.generalInfo.male_female_ratio !== 'undefined') {
        if (typeof this.generalInfo.male_female_ratio.malePercentage !== 'undefined') {
          malePercentage = this.generalInfo.male_female_ratio.malePercentage;
        }
      }
      return malePercentage;
    },
    femalePercentage: function femalePercentage() {
      var femalePercentage = '0';
      if (typeof this.generalInfo.male_female_ratio !== 'undefined') {
        if (typeof this.generalInfo.male_female_ratio.femalePercentage !== 'undefined') {
          femalePercentage = this.generalInfo.male_female_ratio.femalePercentage;
        }
      }
      return femalePercentage;
    },
    averageAge: function averageAge() {
      var averageAge = '0';
      if (typeof this.generalInfo.average_age !== 'undefined') {
        averageAge = this.generalInfo.average_age;
      }
      return averageAge;
    },
    downloadUrl: function downloadUrl() {
      return __WEBPACK_IMPORTED_MODULE_3__config_json__["restEndpoint"] + '/reservation/' + this.reservationId + '/participants/download';
    },
    groupSize: function groupSize() {
      var groupSize = '0';
      if (typeof this.generalInfo.group_size !== 'undefined') {
        groupSize = this.generalInfo.group_size;
      }
      return groupSize;
    },
    showAgeCategories: function showAgeCategories() {
      return this.entity.name !== 'aircruise' && this.entity.name !== 'friendshipcruises';
    }
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      this.loadingOne = true;
      this.loadingTwo = true;
      __WEBPACK_IMPORTED_MODULE_1__api_userApi__["a" /* default */].getParticipants(this.reservationId, function (data) {
        _this2.participants = data.participants;
        _this2.loadingOne = false;
      });
      __WEBPACK_IMPORTED_MODULE_1__api_userApi__["a" /* default */].getGeneralInfo(this.reservationId, function (data) {
        _this2.generalInfo = data.general_info;
        _this2.loadingTwo = false;
      });
    },
    downloadParticipantsList: function downloadParticipantsList() {
      __WEBPACK_IMPORTED_MODULE_1__api_userApi__["a" /* default */].downloadParticipantsList(this.reservationId);
    },
    getFirstname: function getFirstname(passenger) {
      return __WEBPACK_IMPORTED_MODULE_2__store_entityStore__["a" /* default */].getFirstname(passenger);
    },
    formatName: function formatName(passenger) {
      return __WEBPACK_IMPORTED_MODULE_2__store_entityStore__["a" /* default */].formatPassengerName(passenger);
    },
    formatNameLong: function formatNameLong(passenger) {
      return __WEBPACK_IMPORTED_MODULE_2__store_entityStore__["a" /* default */].formatPassengerNameLong(passenger);
    }
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_partials_passport__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_partials_passport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_partials_passport__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId'],
  data: function data() {
    return {
      passengers: [],
      isLoading: true,
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: 'fetchData'
  },
  methods: {
    formatName: function formatName(passenger) {
      if (this.entity.name === 'amigo') {
        return passenger.salutation + ' ' + passenger.initials + ' ' + passenger.middlename + ' ' + passenger.lastname;
      }
      return passenger.salutation + ' ' + passenger.initials + ' ' + __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].formatPassengerName(passenger);
    },
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getPassengers(this.reservationId, function (data) {
        _this.passengers = data.passengers;
        _this.isLoading = false;
      });
    },
    downloadPassengerDocument: function downloadPassengerDocument(passenger, document) {
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].downloadPassengerDocument(this.reservationId, passenger.id, document);
    }
  },
  components: {
    passport: __WEBPACK_IMPORTED_MODULE_2__components_partials_passport___default.a
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId', 'reservation'],
  data: function data() {
    return {
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state,
      passengers: this.reservation.passengers
    };
  },

  methods: {
    getNotesArray: function getNotesArray(notes, predicate) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(notes).filter(function (key) {
        return predicate(key);
      }).reduce(function (res, key) {
        return res[key] = notes[key], res;
      }, {});
    },
    getGeneralNotes: function getGeneralNotes(passenger) {
      return this.getNotesArray(passenger.essentials, function (index) {
        return index === 'Algemeen' || index === 'Contact';
      });
    },
    getPreferenceNotes: function getPreferenceNotes(passenger) {
      return this.getNotesArray(passenger.preferences, function (index) {
        return index !== 'Algemeen' && index !== 'Contact';
      });
    },
    getEssentialNotes: function getEssentialNotes(passenger) {
      return this.getNotesArray(passenger.essentials, function (index) {
        return index !== 'Algemeen' && index !== 'Contact';
      });
    },
    passengerHasData: function passengerHasData(passenger) {
      return true;
    }
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId'],
  data: function data() {
    return {
      reservation: {},
      isLoading: true,
      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },

  computed: {
    isPaid: function isPaid() {
      if (this.reservation.isPaid) {
        return this.reservation.isPaid;
      }
      return false;
    },
    showTravelDocuments: function showTravelDocuments() {
      return __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state.name !== 'aircruise';
    },
    showTourleader: function showTourleader() {
      return __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state.name !== 'aircruise';
    },
    showParticipants: function showParticipants() {
      var name = __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state.name;
      return !(name === 'aircruise' || name === 'friendshipcruises' || this.reservation.reservation_type !== 'standard');
    }
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getReservation(this.reservationId, function (data) {
        _this.reservation = data.reservation;
        _this.isLoading = false;
      });
    },
    menuToggle: function menuToggle(event) {
      $('.mobile-menu').slideToggle();
      $(event.target).toggleClass('active');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(12)))

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_entityStore__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reservations_component_list__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_reservations_component_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_reservations_component_list__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId'],
  data: function data() {
    return {
      reservation: {},

      isLoading: true,

      entity: __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state
    };
  },
  created: function created() {
    this.fetchData();
  },

  computed: {
    showTourLeader: function showTourLeader() {
      return __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].state.name !== 'aircruise';
    }
  },
  watch: {},
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getReservation(this.reservationId, function (data) {
        _this.reservation = data.reservation;
        _this.isLoading = false;
      });
    },
    formatName: function formatName(passenger) {
      return __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].formatPassengerName(passenger);
    },
    formatLongName: function formatLongName(passenger) {
      return __WEBPACK_IMPORTED_MODULE_1__store_entityStore__["a" /* default */].formatPassengerNameLong(passenger);
    }
  },
  components: {
    componentList: __WEBPACK_IMPORTED_MODULE_2__components_reservations_component_list___default.a
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      reservations: [],
      isLoading: true,
      prefix: 'aankomende'
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    $route: 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getUpcomingReservations(function (data) {
        _this.reservations = data.upcoming_reservations;
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_userApi__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_json__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_userAuthStore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_entityStore__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['reservationId', 'travelPackageType'],
  data: function data() {
    return {
      vouchers: [],
      isLoading: true,
      token: __WEBPACK_IMPORTED_MODULE_2__store_userAuthStore__["a" /* default */].state.token,
      entity: __WEBPACK_IMPORTED_MODULE_3__store_entityStore__["a" /* default */].state
    };
  },

  computed: {
    show: function show() {
      return this.viewableVouchers.length > 0 && this.entity.name !== 'aircruise';
    },
    viewableVouchers: function viewableVouchers() {
      var _this = this;

      return this.vouchers.filter(function (voucher) {
        return _this.showVoucher(voucher);
      });
    },
    downloadUrl: function downloadUrl() {
      return __WEBPACK_IMPORTED_MODULE_1__config_json__["restEndpoint"] + '/reservation/' + this.reservationId + '/download-voucher';
    }
  },
  created: function created() {
    this.fetchData();
  },

  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].getVouchers(this.reservationId, function (data) {
        _this2.isLoading = false;
        _this2.vouchers = data.vouchers;
      });
    },
    downloadVoucher: function downloadVoucher(voucher) {
      __WEBPACK_IMPORTED_MODULE_0__api_userApi__["a" /* default */].downloadVoucher(this.reservationId, voucher, voucher.label);
    },
    showVoucher: function showVoucher(voucher) {
      var isHotelVoucher = voucher.voucher_type === 'accommodation_hotel';
      var isActivityVoucher = voucher.voucher_type === 'activity_full_page';
      var isShipVoucher = voucher.voucher_type === 'accommodation_ship';
      var isPickUpVoucher = voucher.voucher_type === 'pick_up_full_page';
      var show = isHotelVoucher || isActivityVoucher || isShipVoucher || isPickUpVoucher;
      if (isPickUpVoucher) {
        if (this.entity.name === 'amicitia') {
          if (this.travelPackageType === 'fly_trip') {
            show = false;
          }
        } else if (this.entity.name === 'amigo') {
          if (this.travelPackageType !== 'touring_car_trip') {
            show = false;
          }
        } else if (this.entity.name === 'ncrv-reizen') {
          if (this.travelPackageType !== 'touring_car_trip') {
            show = false;
          }
        }
      }

      if (this.entity.name === 'amigo') {
        if (isHotelVoucher || isShipVoucher) {
          show = false;
        }
      }
      return show;
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a());

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_dashboard__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_portal_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_portal_dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_personal_info__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_portal_personal_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_portal_personal_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_portal_reservations__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_portal_reservations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_portal_reservations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_portal_contact__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_portal_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_portal_contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_reservations_upcoming__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_reservations_upcoming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_reservations_upcoming__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_reservations_archive__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_reservations_archive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_reservations_archive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_reservations_reservation__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_reservations_reservation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_reservations_reservation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_reservations_invoice__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_reservations_invoice___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_reservations_invoice__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_reservations_travel_package__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_reservations_travel_package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_reservations_travel_package__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_reservations_documents__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_reservations_documents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_reservations_documents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_reservations_participants__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_reservations_participants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_reservations_participants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_reservations_insurances__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_reservations_insurances___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_reservations_insurances__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_reservations_passengers__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_reservations_passengers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_reservations_passengers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_reservations_preferences__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_reservations_preferences___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_reservations_preferences__);

























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_cookie___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  routes: [{
    path: '/',
    redirect: '/login',
    meta: { auth: false }
  }, {
    path: '/login',
    component: __WEBPACK_IMPORTED_MODULE_5__components_login___default.a,
    meta: { auth: false }
  }, {
    path: '/my',
    redirect: '/my-dashboard',
    component: __WEBPACK_IMPORTED_MODULE_6__components_portal___default.a,
    meta: { auth: true },
    children: [{
      path: '/my-dashboard',
      component: __WEBPACK_IMPORTED_MODULE_7__components_portal_dashboard___default.a,
      meta: { auth: true }
    }, {
      path: '/my-personal-info',
      component: __WEBPACK_IMPORTED_MODULE_8__components_portal_personal_info___default.a,
      meta: { auth: true }
    }, {
      path: '/contact',
      component: __WEBPACK_IMPORTED_MODULE_10__components_portal_contact___default.a,
      meta: { auth: true }
    }, {
      path: '/my-reservations',
      redirect: '/my-reservations/upcoming',
      component: __WEBPACK_IMPORTED_MODULE_9__components_portal_reservations___default.a,
      meta: { auth: true },
      children: [{
        path: 'upcoming',
        component: __WEBPACK_IMPORTED_MODULE_11__components_reservations_upcoming___default.a,
        meta: { auth: true }
      }, {
        path: 'archive',
        component: __WEBPACK_IMPORTED_MODULE_12__components_reservations_archive___default.a,
        meta: { auth: true }
      }]
    }, {
      path: '/my-reservation/:reservationId',
      name: 'reservation',
      redirect: { name: 'res-travel-package' },
      component: __WEBPACK_IMPORTED_MODULE_13__components_reservations_reservation___default.a,
      props: true,
      meta: { auth: true },
      children: [{
        path: 'travel-package',
        component: __WEBPACK_IMPORTED_MODULE_15__components_reservations_travel_package___default.a,
        name: 'res-travel-package',
        props: true,
        meta: { auth: true }
      }, {
        path: 'invoice',
        component: __WEBPACK_IMPORTED_MODULE_14__components_reservations_invoice___default.a,
        name: 'res-invoice',
        props: true,
        meta: { auth: true }
      }, {
        path: 'documents',
        component: __WEBPACK_IMPORTED_MODULE_16__components_reservations_documents___default.a,
        name: 'res-docs',
        props: true,
        meta: { auth: true }
      }, {
        path: 'participants',
        component: __WEBPACK_IMPORTED_MODULE_17__components_reservations_participants___default.a,
        name: 'res-participants',
        props: true,
        meta: { auth: true }
      }, {
        path: 'insurances',
        component: __WEBPACK_IMPORTED_MODULE_18__components_reservations_insurances___default.a,
        name: 'res-insurances',
        props: true,
        meta: { auth: true }
      }, {
        path: 'passengers',
        component: __WEBPACK_IMPORTED_MODULE_19__components_reservations_passengers___default.a,
        name: 'res-passengers',
        props: true,
        meta: { auth: true }
      }, {
        path: 'preferences',
        component: __WEBPACK_IMPORTED_MODULE_20__components_reservations_preferences___default.a,
        name: 'res-preferences',
        props: true,
        meta: { auth: true }
      }]
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.meta.auth) {
    if (!__WEBPACK_IMPORTED_MODULE_4__store_userAuthStore__["a" /* default */].state.loggedIn) {
      next({ path: '/login' });
    }
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/glyphicons-halflings-regular.8988968.svg";

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/agro.81e8064.png";

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amigo.e7aad90.png";

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/friendshipcruises.ac4a948.png";

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hannick.f6dde05.png";

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ncrv-reizen.6a3e096.png";

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/agro.81e8064.png";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amicitia.e1c3cad.png";

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amigo.0efc9b1.png";

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/friendshipcruises.5020f2d.png";

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hannick.20a5ff2.png";

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ncrv-reizen.c224791.png";

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aircruise.bf7d832.png";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amicitia.75d49c6.png";

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/amigo.f8751da.png";

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hannick.00ecff2.png";

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.fa27723.woff";

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/glyphicons-halflings-regular.448c34a.woff2";

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(466)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(544),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(463)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(540),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(464)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(541),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(453)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(183),
  /* template */
  __webpack_require__(530),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(460)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(184),
  /* template */
  __webpack_require__(537),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(471)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(186),
  /* template */
  __webpack_require__(549),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(467)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(459)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(536),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(461)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(538),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(476)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(554),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(462)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(539),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(465)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(543),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(468)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(193),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(456)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(194),
  /* template */
  __webpack_require__(533),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(475)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(195),
  /* template */
  __webpack_require__(553),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(457)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(196),
  /* template */
  __webpack_require__(534),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(458)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(197),
  /* template */
  __webpack_require__(535),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(473)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(198),
  /* template */
  __webpack_require__(551),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(474)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(552),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(470)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(200),
  /* template */
  __webpack_require__(548),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(469)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(201),
  /* template */
  __webpack_require__(547),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(454)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(202),
  /* template */
  __webpack_require__(531),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(472)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(203),
  /* template */
  __webpack_require__(550),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(455)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(204),
  /* template */
  __webpack_require__(532),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    class: {
      inithide: !_vm.show
    }
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [(!_vm.isLoading) ? _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_c('entity-text', {
    attrs: {
      "text": "destination"
    }
  }), _vm._v(": " + _vm._s(_vm.reservation.travel_package_name) + " "), _c('i', {
    staticClass: "fa fa-suitcase pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "padding-bottom": "0",
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-column md-75"
  }, [_c('p', [_vm._v(_vm._s(_vm.reservation.start_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-column md-75"
  }, [_c('p', [_vm._v(_vm._s(_vm.reservation.end_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-column md-75"
  }, [_c('p', [_vm._v(_vm._s(_vm.reservation.days))])])]), _vm._v(" "), (_vm.showTourLeader) ? _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "card-column md-25"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_c('entity-text', {
    attrs: {
      "text": "tourLeader"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-column md-75"
  }, [(_vm.reservation.tour_leaders && _vm.reservation.tour_leaders.length > 0) ? _c('p', _vm._l((_vm.reservation.tour_leaders), function(tour_leader, key, index) {
    return _c('ul', {
      staticStyle: {
        "list-style": "none"
      }
    }, [_c('li', [_c('strong', [_vm._v(_vm._s(_vm.formatLongName(tour_leader)))])]), _vm._v(" "), _c('li', [_vm._v("Telefoon: " + _vm._s(tour_leader.tel_number ? tour_leader.tel_number : '-'))]), _vm._v(" "), _c('li', [_vm._v("Email: " + _vm._s(tour_leader.email ? tour_leader.email : '-'))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.reservation.tour_leaders && _vm.reservation.tour_leaders.length === 0) ? _c('p', [_vm._v("Geen "), _c('entity-text', {
    attrs: {
      "text": "tourLeader"
    }
  })], 1) : _vm._e()])]) : _vm._e()])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-12 col-sm-12 col-xs-12"
  }, [_c('component-list', {
    attrs: {
      "reservationId": _vm.reservationId
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column md-25"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Vertrekdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column md-25"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Terugkomstdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column md-25"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Aantal dagen")])])
}]}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', [_c('div', {
    staticClass: "grid-list"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "grid-content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.vouchers.length > 0) ? _c('div', _vm._l((_vm.viewableVouchers), function(voucher, key, index) {
    return (_vm.showVoucher(voucher)) ? _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6"
    }, [_c('div', {
      staticClass: "grid-item"
    }, [_c('h4', [_vm._v(_vm._s(voucher.label))]), _vm._v(" "), _c('p', [_c('i', {
      staticClass: "fa fa-calendar",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(voucher.date))]), _vm._v(" "), _c('div', {
      staticClass: "row grid-item-footer"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('button', {
      staticClass: "md-btn pull-right",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          return _vm.downloadVoucher(voucher)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _vm._m(1, true)])])]) : _vm._e()
  }), 0) : _c('div', {
    staticClass: "col-xs-12 col-sm-21 col-md-6 col-lg-6"
  }, [_vm._m(2)])])]) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-head"
  }, [_c('h3', [_vm._v("\r\n         Vouchers "), _c('i', {
    staticClass: "fa fa-list-alt pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('small', {
    staticClass: "text-info"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-item"
  }, [_c('p', [_vm._v("Geen vouchers te downloaden")])])
}]}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-10 col-lg-10"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content padding-top"
  }, _vm._l((_vm.travelDocuments), function(travelDocument) {
    return _c('div', {
      staticClass: "card-row"
    }, [_c('div', {
      staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8"
    }, [_c('span', [_vm._v(_vm._s(travelDocument.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4"
    }, [_c('button', {
      staticClass: "md-btn pull-right",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.downloadTravelDocument(travelDocument)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._l((_vm.passengers), function(passenger) {
    return (passenger.documents.length > 0) ? _c('div', {
      staticClass: "grid-container"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_c('div', {
      staticClass: "card-head"
    }, [_c('h3', [_vm._v("Reisdocumenten " + _vm._s(_vm.formatName(passenger)))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, _vm._l((passenger.documents), function(document) {
      return _c('div', {
        staticClass: "card-row"
      }, [_c('div', {
        staticClass: "col-xs-8 col-sm-8 col-md-8 col-lg-8"
      }, [_c('span', [_vm._v(_vm._s(document.name))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-4 col-sm-4 col-md-4 col-lg-4"
      }, [_c('button', {
        staticClass: "md-btn pull-right",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.downloadPassengerDocument(passenger, document)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-download",
        attrs: {
          "aria-hidden": "true"
        }
      })])])])
    }), 0), _vm._v(" "), _vm._m(2, true)])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-10 col-lg-10"
  }, [_c('voucher-list', {
    attrs: {
      "reservationId": _vm.reservationId,
      "travel-package-type": _vm.reservation.travel_package_type
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Reisdocumenten algemeen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('p', {
    staticClass: "text-info"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('p', {
    staticClass: "text-info"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])])])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-8"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content padding-top"
  }, [(_vm.hasInsurances()) ? _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.hasInsurances()) ? _c('table', {
    staticClass: "table table-hover table-filter-default"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.passengers), function(passenger) {
    return _c('tbody', _vm._l((passenger.insurances), function(insurance) {
      return _c('tr', [_c('td', [_vm._v("\r\n                  " + _vm._s(_vm.formatName(passenger.passenger)) + "\r\n                ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                  " + _vm._s(insurance.name) + "\r\n                ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                  " + _vm._s(_vm.getRateIcon(insurance.rate_type)) + _vm._s(insurance.rate) + "\r\n                ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                  " + _vm._s(insurance.rate_type) + "\r\n                ")])])
    }), 0)
  })], 2) : _vm._e()]) : _c('div', [_c('p', [_vm._v("Er zijn geen verzekeringen afgesloten.")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n          Verzekeringen\r\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Passagier")]), _vm._v(" "), _c('th', [_vm._v("Verzekering")]), _vm._v(" "), _c('th', [_vm._v("Prijs")]), _vm._v(" "), _c('th', [_vm._v("Prijs type")])])])
}]}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-8"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n           Factuur (" + _vm._s(_vm.invoice.invoice_number) + ") "), _c('i', {
    staticClass: "fa fa-file pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.invoice.invoice_lines), function(invoiceLine) {
    return (invoiceLine.price > 0) ? _c('tr', [_c('td', [_vm._v(_vm._s(invoiceLine.description))]), _vm._v(" "), _c('td', [_vm._v("€" + _vm._s(invoiceLine.total))])]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-responsive"
  }, [_c('tbody', [_vm._l((_vm.invoice.payments), function(payment) {
    return (payment.payment_type == 'upfront' || payment.payment_type == 'rest') ? _c('tr', [_c('td', {
      staticClass: "col-md-8"
    }, [(payment.payment_type == 'upfront') ? _c('span', [_vm._v("Aanbetaling")]) : _vm._e(), _vm._v(" "), (payment.payment_type == 'rest') ? _c('span', [_vm._v("Restant")]) : _vm._e(), _vm._v(" - " + _vm._s(payment.payment_date) + "\r\n                "), (payment.payment_status == 'paid') ? _c('span', [_vm._v("(Betaald)")]) : _vm._e(), _vm._v(" "), (payment.payment_status == 'open') ? _c('span', [_vm._v("(Open)")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "col-md-2"
    }, [_vm._v("€" + _vm._s(payment.amount))])]) : _vm._e()
  }), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-md-8"
  }, [_vm._v("Totaal")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("€" + _vm._s(_vm.roundUp(_vm.invoice.total_amount)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Openstaand bedrag")]), _vm._v(" "), _c('th', [_vm._v("€" + _vm._s(_vm.roundUp(_vm.invoice.total_amount - _vm.invoice.amount_paid)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Bedrag betaald")]), _vm._v(" "), _c('th', [_vm._v("€" + _vm._s(_vm.roundUp(_vm.invoice.amount_paid)))])])], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "md-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadInvoiceAttachment(_vm.invoice.id)
      }
    }
  }, [_vm._v("Download factuurbijlage")]), _vm._v(" "), _c('button', {
    staticClass: "md-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadInvoice(_vm.invoice.id)
      }
    }
  }, [_vm._v("Download factuur")])]), _vm._v(" "), _vm._m(1)])]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "col-md-8"
  }, [_vm._v("Omschrijving")]), _vm._v(" "), _c('th', {
    staticClass: "col-md-2"
  }, [_vm._v("Totaal")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('small', {
    staticClass: "text-info"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])
}]}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-container-columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_c('entity-text', {
    attrs: {
      "text": "welcomeTextTitle"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-partial"
  }, [_c('div', {
    staticClass: "card-partial-content"
  }, [_c('p', [_c('entity-text', {
    attrs: {
      "text": "welcomeText"
    }
  })], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n                Aankomende\r\n                "), _c('entity-text', {
    attrs: {
      "text": "voyage"
    }
  }), _vm._v(" "), (_vm.entity.name == 'friendshipcruises') ? _c('i', {
    staticClass: "fa fa-ship  pull-right"
  }) : _vm._e()], 1)]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoadingReservation
    }
  }), _vm._v(" "), (!_vm.isLoadingReservation) ? _c('div', {
    staticClass: "card-content"
  }, [(_vm.upcomingRes) ? _c('div', [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_c('entity-text', {
    attrs: {
      "text": "destination"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.travel_package_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.start_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.end_date))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.days) + " dagen")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(_vm._s(_vm.upcomingRes.reservation_number))])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-column"
  }, [_c('router-link', {
    staticClass: "md-btn pull-right",
    attrs: {
      "tag": "button",
      "to": {
        name: 'reservation',
        params: {
          reservationId: _vm.upcomingRes.id
        }
      }
    }
  }, [_vm._v("\r\n                      Meer info\r\n                    ")])], 1)])]) : _c('div', [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v("Geen aankomende "), _c('entity-text', {
    attrs: {
      "text": "voyage"
    }
  })], 1)])])])]) : _vm._e()], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Vertrekdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Terugkomstdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Aantal dagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Reserveringsnummer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(" ")])])
}]}

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-left"
  }, [_c('div', {
    staticClass: "logo"
  }, [(_vm.entity.name == 'amigo') ? _c('img', {
    attrs: {
      "src": __webpack_require__(495),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'amicitia') ? _c('img', {
    attrs: {
      "src": __webpack_require__(494),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'hannick') ? _c('img', {
    attrs: {
      "src": __webpack_require__(497),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'friendshipcruises') ? _c('img', {
    attrs: {
      "src": __webpack_require__(496),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'davincitravel') ? _c('img', {
    attrs: {
      "src": __webpack_require__(155),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'aircruise') ? _c('img', {
    attrs: {
      "src": __webpack_require__(154),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'ncrv-reizen') ? _c('img', {
    attrs: {
      "src": __webpack_require__(498),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'agro') ? _c('img', {
    attrs: {
      "src": __webpack_require__(493),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu-container"
  }, [_c('nav', {
    staticClass: "navbar-mijnomgeving"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/my-dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\r\n          Home\r\n        ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/my-personal-info"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "personalPronoun"
    }
  }), _vm._v(" Gegevens\r\n        ")], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/my-reservations"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/contact"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\r\n          Contact\r\n        ")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logOut
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\r\n          Uitloggen\r\n        ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu-button"
  }, [_c('a', {
    staticClass: "menu-toggle",
    on: {
      "click": _vm.menuToggle
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-menu"
  }, [_c('nav', {
    staticClass: "navbar-mijnomgeving"
  }, [_c('ul', {
    staticClass: "menu-mobile"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/my-dashboard"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/my-personal-info"
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronoun"
    }
  }), _vm._v(" gegevens\r\n          ")], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/my-reservations"
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1)], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.logOut
    }
  }, [_vm._v("Uitloggen")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "bars"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')])
}]}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronoun"
    }
  }), _vm._v(" gegevens")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.salutation) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.initials) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.firstname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.nickname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.middlename) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.lastname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                        " + _vm._s(_vm.user.date_of_birth) + "\r\n                      ")])])])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(8), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.address) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.postcode) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.city) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.country) + "\r\n                  ")])])]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(13), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.email) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.tel_mobile) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.tel_home) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.tel_work) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 col-md-7 col-lg-7"
  }, [_vm._v("\r\n                    " + _vm._s(_vm.user.tel_contact) + "\r\n                  ")])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('passport', {
    attrs: {
      "passenger": _vm.user,
      "isLoading": _vm.isLoading
    },
    on: {
      "reload": _vm.fetchData
    }
  })], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Persoonsgegevens "), _c('i', {
    staticClass: "fa fa-user pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Aanhef")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Voorletters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Officiële voornamen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Voornaam")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tussenvoegsels")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Achternaam")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Geboortedatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Adresgegevens "), _c('i', {
    staticClass: "fa fa-address-book pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Adres")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Postcode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Plaats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Land")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Contactgegevens "), _c('i', {
    staticClass: "fa fa-phone pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. mobiel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. thuis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. werk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. thuisblijver")])])
}]}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head full-width"
  }, [_c('h3', [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v("\r\n          " + _vm._s(_vm.prefix) + "\r\n          "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  }), _vm._v(" "), (_vm.prefix == 'vorige') ? _c('small', [_vm._v("In dit overzicht worden reizen getoond vanaf 1-1-2017")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-suitcase pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1)]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', [(_vm.reservations.length < 1) ? _c('div', [_c('p', {
    staticStyle: {
      "padding-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\r\n            Geen " + _vm._s(_vm.prefix) + " "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1)]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.reservations), function(reservation) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_c('div', {
      staticClass: "card-head"
    }, [_c('h3', [_vm._v(_vm._s(reservation.travel_package_name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-row"
    }, [_c('div', {
      staticClass: "card-column"
    }, [_c('p', {
      staticClass: "title-text"
    }, [_c('entity-text', {
      attrs: {
        "text": "destination"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.travel_package_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.start_date))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.end_date))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.days) + " dagen")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.reservation_number))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('router-link', {
      staticClass: "md-btn pull-right",
      attrs: {
        "tag": "button",
        "to": {
          name: 'reservation',
          params: {
            reservationId: reservation.id
          }
        }
      }
    }, [_vm._v("\r\n                  Meer info\r\n                ")])], 1)])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Vertrekdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Terugkomstdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Aantal dagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Reserveringsnummer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(" ")])])
}]}

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logo-login"
  }, [(_vm.entity.name == 'amigo') ? _c('img', {
    attrs: {
      "src": __webpack_require__(489),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'amicitia') ? _c('img', {
    staticClass: "amicitia-logo-login",
    attrs: {
      "src": __webpack_require__(488),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'hannick') ? _c('img', {
    staticClass: "hannick-logo-login",
    attrs: {
      "src": __webpack_require__(491),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'friendshipcruises') ? _c('img', {
    staticClass: "friendshipcruises-logo-login",
    attrs: {
      "src": __webpack_require__(490),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'davincitravel') ? _c('img', {
    attrs: {
      "src": __webpack_require__(155),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'aircruise') ? _c('img', {
    attrs: {
      "src": __webpack_require__(154),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'ncrv-reizen') ? _c('img', {
    attrs: {
      "src": __webpack_require__(492),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'agro') ? _c('img', {
    attrs: {
      "src": __webpack_require__(487),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card paper card-login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-alerts"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [(_vm.usernameInvalid) ? _c('li', [_vm._v("Email is verkeerd.")]) : _vm._e(), _vm._v(" "), (_vm.passwordInvalid) ? _c('li', [_vm._v("Boekings nummer is verkeerd.")]) : _vm._e(), _vm._v(" "), (_vm.combinationInvalid) ? _c('li', [_vm._v("Email + boekings nummer combinatie is verkeerd.")]) : _vm._e(), _vm._v(" "), (_vm.connectionError) ? _c('li', [_vm._v("Er is iets fout gegaan.")]) : _vm._e(), _vm._v(" "), (_vm.userAuth.tokenExpired) ? _c('li', [_vm._v("Sessie is verlopen. log opniew in om verder the gaan.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "md-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: {
      invalid: _vm.usernameInvalid
    },
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', [_vm._v("E-mail")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "md-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: {
      invalid: _vm.passwordInvalid
    },
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', [_vm._v("Reserveringsnummer")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "md-btn pull-right",
    on: {
      "click": _vm.submitUser
    }
  }, [_vm._v("Inloggen")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-login"
  }, [(_vm.entity.name == 'amigo') ? _c('img', {
    attrs: {
      "src": __webpack_require__(501),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'amicitia') ? _c('img', {
    attrs: {
      "src": __webpack_require__(500),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'hannick') ? _c('img', {
    attrs: {
      "src": __webpack_require__(502),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'aircruise') ? _c('img', {
    attrs: {
      "src": __webpack_require__(499),
      "alt": ""
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Log in")])])
}]}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.outText))])
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passport_number),
      expression: "passport_number"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Paspoortnummer"
    },
    domProps: {
      "value": (_vm.passport_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passport_number = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('passport_number')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('passport_number')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country_of_birth),
      expression: "country_of_birth"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Geboorteland"
    },
    domProps: {
      "value": (_vm.country_of_birth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.country_of_birth = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('country_of_birth')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('country_of_birth')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city_of_birth),
      expression: "city_of_birth"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Geboorteplaats"
    },
    domProps: {
      "value": (_vm.city_of_birth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.city_of_birth = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('city_of_birth')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('city_of_birth')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passport_country),
      expression: "passport_country"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Land uitgifte"
    },
    domProps: {
      "value": (_vm.passport_country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passport_country = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('passport_country')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('passport_country')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passport_city),
      expression: "passport_city"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Plaats uitgifte"
    },
    domProps: {
      "value": (_vm.passport_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passport_city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('passport_city')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('passport_city')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date_issue_passport),
      expression: "date_issue_passport"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Datum uitgifte"
    },
    domProps: {
      "value": (_vm.date_issue_passport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.date_issue_passport = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('date_issue_passport')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('date_issue_passport')))]) : _vm._e()]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passport_expire_date),
      expression: "passport_expire_date"
    }],
    staticClass: "row-input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editing,
      "placeholder": "Geldig tot"
    },
    domProps: {
      "value": (_vm.passport_expire_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passport_expire_date = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasError('passport_expire_date')) ? _c('small', {
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.hasError('passport_expire_date')))]) : _vm._e()]), _vm._v(" "), _vm._m(7)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('button', {
    staticClass: "md-btn left",
    class: {
      hide: !_vm.editing
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Annuleren")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
  }, [_c('button', {
    staticClass: "md-btn right",
    class: {
      hide: !_vm.editing
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Opslaan")]), _vm._v(" "), _c('button', {
    staticClass: "md-btn right",
    class: {
      hide: _vm.editing
    },
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Aanpassen")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n            Paspoortgegevens\r\n            "), _c('i', {
    staticClass: "fa fa-id-card pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('label', {
    staticClass: "title-text"
  }, [_vm._v("Paspoortnummer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Geboorteplaats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Plaats uitgifte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Datum uitgifte")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('small', [_vm._v("dd/mm/jjjj")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Geldig tot")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('small', [_vm._v("dd/mm/jjjj")])])
}]}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('flights-view', {
    attrs: {
      "flights": _vm.flights
    }
  }), _vm._v(" "), _vm._l((_vm.components), function(component) {
    return (component.show) ? _c('component-view', {
      key: component.id,
      attrs: {
        "component": component
      }
    }) : _vm._e()
  })], 2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n          Onderdelen worden opgehaald\r\n        ")])])
}]}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "tab-container-columns"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card paper",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('ul', {
    staticClass: "simple-ul"
  }, [_c('li', [_vm._v(_vm._s(_vm.entity.label))]), _vm._v(" "), _c('li', [_vm._v("Veersedijk 95")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.entity.postcodeCity))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('ul', {
    staticClass: "simple-ul"
  }, [(_vm.entity.tel) ? _c('li', [_c('b', [_vm._v("Tel:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.telTo
    }
  }, [_vm._v(_vm._s(_vm.entity.tel))])]) : _vm._e(), _vm._v(" "), (_vm.entity.telInt) ? _c('li', [_c('b', [_vm._v("Tel int:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.telIntTo
    }
  }, [_vm._v(_vm._s(_vm.entity.telInt))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('span', [_c('b', [_vm._v("Email: ")]), _c('a', {
    attrs: {
      "href": _vm.mailToAddress
    }
  }, [_vm._v(_vm._s(_vm.mailAddress))])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('span', [_c('b', [_vm._v("Internet: ")]), _c('a', {
    attrs: {
      "href": _vm.entity.websiteLink,
      "target": "_BLANK"
    }
  }, [_vm._v(_vm._s(_vm.entity.website))])])])])])])]), _vm._v(" "), (_vm.entity.postbox) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card paper",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('ul', {
    staticClass: "simple-ul"
  }, [_c('li', [_vm._v(_vm._s(_vm.entity.postbox))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.entity.postboxAddress))])])])])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Bezoekadres:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Postadres:")])])
}]}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h3', [(_vm.component.type == 'hotel') ? _c('span', [_vm._v("Accommodatie:")]) : _vm._e(), _vm._v(" "), (_vm.component.type == 'ship') ? _c('span', [_vm._v("Hotelschip:")]) : _vm._e(), _vm._v(" "), (_vm.component.type == 'pickUp') ? _c('span', [_vm._v("Vervoer: ")]) : _vm._e(), _vm._v(_vm._s(_vm.component.name) + "\r\n          "), _c('i', {
    staticClass: "pull-right",
    class: _vm.iconClass,
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.component.type == 'hotel') ? _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Verzorgingstype")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.care_type))])])]), _vm._v(" "), (_vm.component.address.toLowerCase() != 'n.v.t.') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Adres")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.address))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Stad")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.city))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Land")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.country))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.component.rooms), function(room) {
    return _c('div', {
      staticClass: "card-partial"
    }, [_c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v(_vm._s(room.roomType) + " "), (room.occupation != room.capacity) ? _c('span', {
      staticClass: "sub-title"
    }, [_vm._v("Afwijkende bezetting van " + _vm._s(room.occupation))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('label', [_vm._v("Personen")]), _vm._v(" "), _vm._l((room.passengers), function(passenger) {
      return _c('p', [_vm._v(_vm._s(_vm.formatName(passenger)))])
    })], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type == 'ship') ? _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Verzorgingstype")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.care_type))])])]), _vm._v(" "), _vm._l((_vm.component.cabins), function(cabin) {
    return _c('div', {
      staticClass: "card-partial"
    }, [_c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v(_vm._s(cabin.cabinType) + " "), (cabin.occupation != cabin.capacity) ? _c('span', {
      staticClass: "sub-title"
    }, [_vm._v("Afwijkende bezetting van " + _vm._s(cabin.occupation))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('label', [_vm._v("Personen")]), _vm._v(" "), _vm._l((cabin.passengers), function(passenger) {
      return _c('p', [_vm._v(_vm._s(_vm.formatName(passenger)))])
    })], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type == 'pickUp') ? _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.transport_type))])])]), _vm._v(" "), _vm._l((_vm.component.locations), function(location) {
    return _c('div', {
      staticClass: "card-partial"
    }, [_c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v("Opstapplaats: " + _vm._s(location.startLocation) + " "), (location.startLocation != location.endLocation) ? _c('span', [_vm._v("| Uitstapplaats: " + _vm._s(location.endLocation))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('label', [_vm._v("Personen")]), _vm._v(" "), _vm._l((location.passengers), function(passenger) {
      return _c('p', [_vm._v(_vm._s(_vm.formatName(passenger)))])
    })], 2)])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.component.type == 'activity' || _vm.component.type == 'arrangement') ? _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-xs-4 col-md-4 col-lg-4"
  }, [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.component.category))])])]), _vm._v(" "), _vm._l((_vm.component.options), function(option) {
    return _c('div', {
      staticClass: "card-partial"
    }, [(option.option_name !== 'Standaard') ? _c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v(_vm._s(option.option_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('label', [_vm._v("Personen")]), _vm._v(" "), _vm._l((option.passengers), function(passenger) {
      return _c('p', [_vm._v(_vm._s(_vm.formatName(passenger)))])
    })], 2)])
  })], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.reservation.travel_package_name))]), _vm._v(" "), _c('div', {
    staticClass: "tab-navigation-reservation"
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "white"
    }
  }), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-travel-package',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "voyage"
    }
  })], 1), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-passengers',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("Reizigers")])]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-insurances',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("Verzekeringen")])]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-invoice',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("Factuur")])]), _vm._v(" "), (_vm.isPaid && _vm.showTravelDocuments) ? _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-docs',
        params: {
          reservationId: _vm.reservation.id,
          reservation: _vm.reservation
        }
      }
    }
  }, [_c('span', [_vm._v("Reisdocumenten")])]) : _vm._e(), _vm._v(" "), (_vm.isPaid && _vm.showParticipants) ? _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-participants',
        params: {
          reservationId: _vm.reservation.id
        }
      }
    }
  }, [_c('span', [_vm._v("Deelnemers")])]) : _vm._e(), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": {
        name: 'res-preferences',
        params: {
          reservationId: _vm.reservation.id,
          reservation: _vm.reservation
        }
      }
    }
  }, [_c('span', [_vm._v("Bijzonderheden")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.passengers), function(passenger) {
    return _c('div', {
      staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_c('div', {
      staticClass: "card-head"
    }, [_c('h3', [_vm._v(_vm._s(passenger.firstname))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "card-content padding-top"
    }, [_c('h4', [_vm._v("Algemeen")]), _vm._v(" "), _vm._l((_vm.getGeneralNotes(passenger)), function(note, index) {
      return _c('div', {
        staticClass: "card-row"
      }, [_c('div', {
        staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3"
      }, [_c('span', [_vm._v(_vm._s(index))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9"
      }, [(note) ? _c('span', [_vm._v(_vm._s(note))]) : _c('span', [_vm._v("-")])])])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "card-content padding-top"
    }, [_c('h4', [_vm._v("Preferenties")]), _vm._v(" "), _vm._l((_vm.getPreferenceNotes(passenger)), function(note, index) {
      return _c('div', {
        staticClass: "card-row"
      }, [_c('div', {
        staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3"
      }, [_c('span', [_vm._v(_vm._s(index))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9"
      }, [(note) ? _c('span', [_vm._v(_vm._s(note))]) : _c('span', [_vm._v("-")])])])
    })], 2)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "card-content padding-top"
    }, [_c('h4', [_vm._v("Essenties")]), _vm._v(" "), _vm._l((_vm.getEssentialNotes(passenger)), function(note, index) {
      return _c('div', {
        staticClass: "card-row"
      }, [_c('div', {
        staticClass: "col-xs-3 col-sm-3 col-md-3 col-lg-3"
      }, [_c('span', [_vm._v(_vm._s(index))])]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 col-sm-9 col-md-9 col-lg-9"
      }, [(note) ? _c('span', [_vm._v(_vm._s(note))]) : _c('span', [_vm._v("-")])])])
    })], 2)])])])])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portal"
  }, [_c('menu-left', {
    attrs: {
      "logged-in": _vm.userAuth.loggedIn
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-container"
  }, [_c('router-view'), _vm._v(" "), _vm._m(0)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "powered-by-footer"
  }, [_c('small', [_vm._v("\r\n        Powered by "), _c('a', {
    attrs: {
      "href": "http://travelplugin.nl",
      "target": "_BLANK"
    }
  }, [_vm._v("Travelplugin")])])])
}]}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_c('div', {
    staticClass: "card-head full-width"
  }, [_c('h3', [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v("\r\n          " + _vm._s(_vm.prefix) + "\r\n          "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  }), _vm._v(" "), (_vm.prefix == 'vorige') ? _c('small', [_vm._v("In dit overzicht worden reizen getoond vanaf 1-1-2017")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-suitcase pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1)]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', [(_vm.reservations.length < 1) ? _c('div', [_c('p', {
    staticStyle: {
      "padding-top": "10px",
      "padding-bottom": "10px"
    }
  }, [_vm._v("\r\n            Geen " + _vm._s(_vm.prefix) + " "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1)]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.reservations), function(reservation) {
    return _c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_c('div', {
      staticClass: "card-head"
    }, [_c('h3', [_vm._v(_vm._s(reservation.travel_package_name))])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-row"
    }, [_c('div', {
      staticClass: "card-column"
    }, [_c('p', {
      staticClass: "title-text"
    }, [_c('entity-text', {
      attrs: {
        "text": "destination"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.travel_package_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.start_date))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.end_date))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.days) + " dagen")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('p', [_vm._v(_vm._s(reservation.reservation_number))])])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "card-column"
    }, [_c('router-link', {
      staticClass: "md-btn pull-right",
      attrs: {
        "tag": "button",
        "to": {
          name: 'reservation',
          params: {
            reservationId: reservation.id
          }
        }
      }
    }, [_vm._v("\r\n                  Meer info\r\n                ")])], 1)])])])])
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Vertrekdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Terugkomstdatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Aantal dagen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v("Reserveringsnummer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-column"
  }, [_c('p', [_vm._v(" ")])])
}]}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Aanhef")]), _vm._v(" "), (_vm.entity.name == 'amigo') ? _c('th', [_vm._v("Voornaam")]) : _c('th', [_vm._v("Voorletters")]), _vm._v(" "), _c('th', [_vm._v("Achternaam")]), _vm._v(" "), _c('th', [_vm._v("Woonplaats")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.participants), function(participant) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(participant.salutation))]), _vm._v(" "), (_vm.entity.name == 'amigo') ? _c('td', [_vm._v(_vm._s(_vm.getFirstname(participant)))]) : _c('td', [_vm._v(_vm._s(participant.initials))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(participant.middlename) + " " + _vm._s(participant.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(participant.city))])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('button', {
    staticClass: "md-btn pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadParticipantsList()
      }
    }
  }, [_vm._v("Download")])]), _vm._v(" "), _vm._m(1)])])], 1)]), _vm._v(" "), (!_vm.isLoading && _vm.showAgeCategories) ? _c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-4 col-lg-4"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Percentage mannelijk")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v(_vm._s(_vm.malePercentage) + "%")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Percentage vrouwelijk")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v(_vm._s(_vm.femalePercentage) + "%")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Gemiddelde leeftijd")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v(_vm._s(_vm.averageAge))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Groepsgrootte")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v(_vm._s(_vm.groupSize))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_vm._m(3), _vm._v(" "), _vm._l((_vm.ageCategories), function(ageCategory) {
    return _c('tr', [_c('th', {
      attrs: {
        "col-md-6": ""
      }
    }, [_vm._v(_vm._s(ageCategory.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "col-md-4": ""
      }
    }, [_vm._v(_vm._s(ageCategory.percentage) + "%")])])
  })], 2)])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n          Deelnemers "), _c('i', {
    staticClass: "fa fa-users pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('small', {
    staticClass: "pull-right text-info sub-text"
  }, [_vm._v("Controleer of pop-ups zijn toegestaan.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Groepssamenstelling")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    attrs: {
      "col-md-6": ""
    }
  }, [_vm._v("Leeftijd")]), _vm._v(" "), _c('td', {
    attrs: {
      "col-md-4": ""
    }
  }, [_vm._v("%")])])
}]}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('loader', {
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), _vm._l((_vm.passengers), function(passenger) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
    }, [_c('h1', [_vm._v(_vm._s(_vm.formatName(passenger)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-5 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_vm._m(0, true), _vm._v(" "), _c('loader', {
      attrs: {
        "show": _vm.isLoading
      }
    }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12 col-xs-12 col-md-12 col-lg-12"
    }, [_c('div', {
      staticClass: "card-row"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                        " + _vm._s(passenger.salutation) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                        " + _vm._s(passenger.initials) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(3, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                        " + _vm._s(passenger.firstname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(4, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                        " + _vm._s(passenger.nickname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(5, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                        " + _vm._s(passenger.middlename) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                        " + _vm._s(passenger.lastname) + "\r\n                      ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(7, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                        " + _vm._s(passenger.date_of_birth) + "\r\n                      ")])])])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_vm._m(8, true), _vm._v(" "), _c('loader', {
      attrs: {
        "show": _vm.isLoading
      }
    }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-row"
    }, [_vm._m(9, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.address) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(10, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.postcode) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(11, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.city) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(12, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.country) + "\r\n                  ")])])]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-5 col-md-12 col-sm-12 col-xs-12"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
    }, [_c('div', {
      staticClass: "card paper"
    }, [_vm._m(13, true), _vm._v(" "), _c('loader', {
      attrs: {
        "show": _vm.isLoading
      }
    }), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "card-row"
    }, [_vm._m(14, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.email) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(15, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.tel_mobile) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(16, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.tel_home) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(17, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.tel_work) + "\r\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-row"
    }, [_vm._m(18, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7 col-sm-7 col-md-7 col-lg-7"
    }, [_vm._v("\r\n                    " + _vm._s(passenger.tel_contact) + "\r\n                  ")])])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }, [_c('passport', {
      attrs: {
        "passenger": passenger,
        "isLoading": _vm.isLoading
      },
      on: {
        "reload": _vm.fetchData
      }
    })], 1)])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Persoonsgegevens "), _c('i', {
    staticClass: "fa fa-user pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Aanhef")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Voorletters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Officiële voornamen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Voornaam")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tussenvoegsels")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Achternaam")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Geboortedatum")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Adresgegevens "), _c('i', {
    staticClass: "fa fa-address-book pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md- col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Adres")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md- col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Postcode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md- col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Plaats")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md- col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Land")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Contactgegevens "), _c('i', {
    staticClass: "fa fa-phone pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. mobiel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. thuis")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. werk")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-5 col-sm-5 col-md-5 col-lg-5"
  }, [_c('span', {
    staticClass: "title-text"
  }, [_vm._v("Tel. thuisblijver")])])
}]}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flights.length > 0) ? _c('div', {
    staticClass: "col-xs-12 col-xs-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "card paper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, _vm._l((_vm.flights), function(flight) {
    return _c('div', {
      staticClass: "card-partial"
    }, [_c('div', {
      staticClass: "card-partial-head"
    }, [_c('h4', [_vm._v(_vm._s(flight.flightType) + "vlucht | " + _vm._s(flight.departureCity) + " - " + _vm._s(flight.arrivalCity))])]), _vm._v(" "), _c('div', {
      staticClass: "card-partial-content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-4 col-lg-4"
    }, [_c('label', [_vm._v("Vluchtnummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(flight.flightnumber))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4 col-lg-4"
    }, [_c('label', [_vm._v("Vertrek")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(flight.dateRanges[0].startDate) + " "), (flight.dateRanges[0].startTime != '00:00') ? _c('span', [_vm._v(_vm._s(flight.dateRanges[0].startTime))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-4 col-lg-4"
    }, [_c('label', [_vm._v("Aankomst")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(flight.dateRanges[0].endDate) + " "), (flight.dateRanges[0].endTime != '00:00') ? _c('span', [_vm._v(_vm._s(flight.dateRanges[0].endTime))]) : _vm._e()])])])])])
  }), 0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("\r\n          Vluchten\r\n          "), _c('i', {
    staticClass: "fa fa-plane pull-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-navigation-reservation"
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "white"
    }
  }), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": "/my-reservations/upcoming"
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" aankomende "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": "/my-reservations/archive"
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" vorige "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}

/***/ }),
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */
/***/ (function(module, exports) {

module.exports = {"welcomeTextTitle":{"friendshipcruises":"Hartelijk welkom op mijn Friendship Cruises","amigo":"Welkom op Mijn AmiGO Reizen","hannick":"Hartelijk welkom op mijn Hannick Reizen","amicitia":"Hartelijk welkom op mijn Amicitia Reizen","aircruise":"Hartelijk welkom op mijn Air Cruise Collection","ncrv-reizen":"Hartelijk welkom op mijn NCRV Reizen","agro":"Hartelijk welkom op mijn Agro Reizen"},"welcomeText":{"amigo":"Leuk dat je met ons op reis gaat! In deze online omgeving vind je een overzicht van jouw gegevens, kun je de door jouw geboekte reis bekijken, je factuur inzien en je reisdocumenten downloaden.","friendshipcruises":"In deze online omgeving vindt u een overzicht van uw gegevens, kunt u de door u geboekte cruise bekijken, uw factuur en betalingsstatus inzien en eventueel uw reisdocumenten (die tevens per post worden toegestuurd) downloaden ca. 14 dagen voor vertrek.","hannick":"In deze online omgeving vindt u een overzicht van uw gegevens, kunt u de door u geboekte reis bekijken, uw factuur en betalingsstatus inzien en eventueel uw reisdocumenten (die tevens per post worden toegestuurd) downloaden ca. 14 dagen voor vertrek.","amicitia":"In deze online omgeving vindt u een overzicht van uw gegevens, kunt u de door u geboekte reis bekijken, uw factuur en betalingsstatus inzien en eventueel uw reisdocumenten (die tevens per post worden toegestuurd) downloaden ca. 14 dagen voor vertrek.","aircruise":"In deze online omgeving vindt u een overzicht van uw gegevens, kunt u de door u geboekte aircruise bekijken, uw factuur en betalingsstatus inzien.","ncrv-reizen":"In deze online omgeving vindt u een overzicht van uw gegevens, kunt u de door u geboekte reis bekijken, uw factuur en betalingsstatus inzien en uw reisdocumenten downloaden ca. 14 dagen voor vertrek.","agro":"In deze online omgeving vindt u een overzicht van uw gegevens, kunt u de door u geboekte reis bekijken, uw factuur en betalingsstatus inzien en uw reisdocumenten downloaden ca. 14 dagen voor vertrek."},"participantsListMessage":{"amigo":"In tegenstelling tot wat je wellicht gewend bent tref je hier een deelnemerslijst met alleen naam en woonplaats aan. Het is vanwege de nieuwe privacywet namelijk niet langer toegestaan uitgebreide persoonsgegevens te delen van medereizigers.","amicitia":"In tegenstelling tot wat u wellicht gewend bent treft u hier een deelnemerslijst met alleen naam en woonplaats aan. Het is vanwege de nieuwe privacywet namelijk niet langer toegestaan uitgebreide persoonsgegevens te delen van medereizigers.","default":""},"personalPronoun":{"amigo":"Jouw","default":"Uw"},"personalPronounTwo":{"amigo":"Mijn","default":"Uw"},"voyages":{"friendshipcruises":"cruises","aircruise":"aircruises","default":"reizen"},"voyage":{"friendshipcruises":"cruise","aircruise":"aircruise","default":"reis"},"destination":{"friendshipcruises":"Cruise","default":"Bestemming"},"tourLeader":{"friendshipcruises":"Cruiseleader(s)","default":"Reisleider(s)"}}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(160);
__webpack_require__(159);
module.exports = __webpack_require__(161);


/***/ })
],[560]);


// WEBPACK FOOTER //
// static/js/app.8ee87167d1731136d9d9.js